import { BillingConfig } from '../types/operations';
import { ErrorField } from '../../../../types/ErrorField';
import { getErrorMessage } from '../../../../utils/formErrorUtils';

export const EMPTY_BILLING_CONFIG: BillingConfig = {
    generate_billets: null,
    automatic_preventive_collection: null,
    automatic_overdue_collection: null,
};

interface Props {
    value: BillingConfig;
    onChange: (updated: BillingConfig) => void;
    disabled?: boolean;
    errorFields?: ErrorField[];
}

const FIELDS: Array<{ id: keyof BillingConfig; label: string }> = [
    { id: 'generate_billets', label: 'Gerar boletos para cobrança' },
    { id: 'automatic_preventive_collection', label: 'Cobrança preventiva automática' },
    { id: 'automatic_overdue_collection', label: 'Cobrança de vencidos automática' },
];

const BillingConfigSection: React.FC<Props> = ({ value, onChange, disabled, errorFields = [] }) => {
    return (
        <>
            <h2 className="text-xl font-semibold mt-4 mb-4 dark:text-white">Configuração de cobrança</h2>
            <div className="grid grid-cols-12 gap-4 mb-6" role="group" aria-label="Configuração de cobrança">
                {FIELDS.map(({ id, label }) => {
                    const error = getErrorMessage(errorFields, id);
                    return (
                        <fieldset key={id} className="col-span-4">
                            <legend className="text-sm font-medium text-gray-700 dark:text-gray-300 block mb-2">
                                {label}
                            </legend>
                            <div className="flex items-center gap-4">
                                <label className={`flex items-center gap-1.5 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                    <input
                                        type="radio"
                                        name={id}
                                        checked={value[id] === true}
                                        onChange={() => onChange({ ...value, [id]: true })}
                                        disabled={disabled}
                                        aria-label={`${label} - Sim`}
                                        className="w-4 h-4 text-blue-600 dark:text-blue-400"
                                    />
                                    <span className="text-sm font-bold text-blue-600 dark:text-blue-400">Sim</span>
                                </label>
                                <label className={`flex items-center gap-1.5 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                    <input
                                        type="radio"
                                        name={id}
                                        checked={value[id] === false}
                                        onChange={() => onChange({ ...value, [id]: false })}
                                        disabled={disabled}
                                        aria-label={`${label} - Não`}
                                        className="w-4 h-4 text-red-600 dark:text-red-400"
                                    />
                                    <span className="text-sm font-bold text-red-600 dark:text-red-400">Não</span>
                                </label>
                            </div>
                            {error && <p className="text-xs text-red-600 dark:text-red-400 mt-1">{error}</p>}
                        </fieldset>
                    );
                })}
            </div>
        </>
    );
};

export default BillingConfigSection;
